import {
    Button,
    Separator,
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
    useIsMobile,
} from "@elit-hair/elit-ui";
import { useEffect, useState } from "react";
import { TbDialpad } from "react-icons/tb";

import { HeaderCallDialerContent } from "./call-dialer-content";

export function HeaderCallDialer() {
    const [open, setOpen] = useState<boolean>(false);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (!isMobile && open) {
            setOpen(false);
        }
    }, [isMobile, open]);

    return (
        <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
                <Button size="icon" variant="ghost">
                    <TbDialpad size={22} />
                    <span className="sr-only">Call Dialer</span>
                </Button>
            </SheetTrigger>
            <SheetContent className="space-y-4 h-full" aria-describedby={undefined}>
                <SheetHeader>
                    <SheetTitle>Call Dialer</SheetTitle>
                </SheetHeader>
                <Separator />
                <HeaderCallDialerContent />
            </SheetContent>
        </Sheet>
    );
}
